import {Component, OnInit} from '@angular/core';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import { isMPay, isSkycash } from '../../../../core/utils/utils';
import {AgreementModel} from '../../../../core/models/agreement.model';
import {LanguageService} from '../../../services/language.service';
import {AgreementsStateService} from '../../../../core/services/impl/section-services/agreements/agreements-state.service';
import {NavigateManagerService} from '../../../../core/services/navigate-manager.service';

@Component({
  selector: 'app-power-of-attorney-section',
  templateUrl: './power-of-attorney-section.component.html',
  styleUrls: ['./power-of-attorney-section.component.scss']
})
export class PowerOfAttorneySectionComponent implements OnInit {

  agreementText: string;

  get sectionVisible(): boolean {
    return !this.navigateManagerService.isNotificationStep && (isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin;
  }

  get language(): string {
    return this.languageService.getDefaultLanguage().toUpperCase();
  }

  constructor(private urlParamsService: UrlParamsService,
              private languageService: LanguageService,
              private navigateManagerService: NavigateManagerService,
              private agreementsService: AgreementsStateService) { }

  ngOnInit() {
    const powerOfAttorneyAgreement = this.agreementsService.offerAgreements
        .find(agreement => agreement.code.includes('POWER_OF_ATTORNEY'));
    this.agreementText = powerOfAttorneyAgreement ? this.getAgreementValue(powerOfAttorneyAgreement) : '';
  }

  private getAgreementValue(agreement: AgreementModel): string {
    const agreementValues = agreement.details.values.filter(item => item.languageCode.toUpperCase() === this.language);
    if (agreementValues.length > 0) {
      return agreementValues[0].value;
    } else {
      throw new Error(`Agreement does not contain value for given language code: ${this.language}.`);
    }
  }

}
